import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useCallback, useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { BaseCheckboxComponent2 } from '../shared-components/BaseCheckboxComponent2';
import { cumulativeSetterForConfigReportCheckbox, getIsCumulativeConfigReport, getIsReportValidForCumulativeCheckbox, isCumulativeCheckboxDisabled } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConfigReportCumulativeCheckbox = ({
  report,
  onChange
}) => {
  const userInfo = useContext(UserInfoContext);
  const isChecked = getIsCumulativeConfigReport(report);
  const onCumulativeCheckboxChange = useCallback(() => {
    onChange(cumulativeSetterForConfigReportCheckbox(report));
  }, [report, onChange]);
  const {
    isDisabled,
    disabledReason
  } = isCumulativeCheckboxDisabled(report);
  if (!getIsReportValidForCumulativeCheckbox({
    report,
    userInfo
  })) {
    return null;
  }
  return /*#__PURE__*/_jsx(BaseCheckboxComponent2, {
    onChange: onCumulativeCheckboxChange,
    isChecked: isChecked,
    disabled: isDisabled,
    tooltipTitle: disabledReason,
    description: /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.cumulative-checkbox.config.tooltip"
      })
    }),
    descriptionLayout: "horizontal",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.cumulative-checkbox.config.label"
    })
  });
};